import React, { useState, useEffect } from 'react';
import { API_URL, secret_key, storedData, customStyles } from '../Constants';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import CryptoJS from "crypto-js";
import Modal from 'react-modal';
import Select from 'react-select';
import loading1 from "../../assets/loading.gif"
import InfiniteScroll from 'react-infinite-scroll-component';

function SendNewMessage() {
  const { id } = useParams();
  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;
  const [message_data, setMessageData] = useState({});
  const [message_groups, setMessageGroups] = useState('');
  const [loading, setLoading] = useState(true); 

  const queryParams = new URLSearchParams(window.location.search);
  const smsStatus = queryParams.get('sms_status');
  
  const [searchTerm, setSearchTerm] = useState('');
  const [recipients, setRecipient] = useState([]);
  const [generaldata, setGeneraldata] = useState([]);

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes?.toString(CryptoJS.enc.Utf8));
  }
  
  const [companydata, setcompanydata] = useState("");
  let navigate = useNavigate();

  useEffect(() => {
    const fetchNewMessage = async () => {
      try {
        const response = await axios.get(`${API_URL}/get_message_id/${id}`, {
          headers: {
            Authorization: token,
          },
        });
        const message = response.data;
        setMessageData(message);
        setsmsData(message)
        setMessageGroups(message.group_id);
      } catch (error) {
        if (error?.response?.status === 401) {
          navigate(0);
        }
      }
    };

    fetchNewMessage();
  }, [id, token]);

  // useEffect(() => {
  //   const fetchMessageForId = () => {
  //     axios
  //       .get(`${API_URL}/get_message_line_id/${id}`, {
  //         headers: {
  //           Authorization: token,
  //         },
  //       })
  //       .then(response => {
  //         setGeneraldata(response.data);
  //         setLoading(false);
  //       })
  //       .catch(error => {
  //         setLoading(false);
  //       });
  //   };
  
  //   fetchMessageForId();
  // }, [id, token]);
  const fetchMessageForId = () => {
    // axios
    //   .get(`${API_URL}/get_message_line_id_v1/${id}?page=${page}&limit=${50}`, {
    //     headers: {
    //       Authorization: token,
    //     },
    //   })
      let url = `${API_URL}/get_message_line_id_v1/${id}?page=${page}&limit=${50}`;
      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: url,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
      };
      axios
      .request(config)
      .then(response => {
        // setGeneraldata(response.data);
        // setLoading(false);
        if (response.data.length === 0) {
          setHasMore(false);
        } else {
          setGeneraldata([...generaldata, ...response.data]);
          setPage(page + 1);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  };

  useEffect(()=>{
    fetchMessageForId();
  }, [id, token])

  const loadMoreMessages = () => {
    fetchMessageForId();
  }

   //Get company data
   const fetchCompanyByID = () => {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${API_URL}/get_company/${logeduserData?.company_id}`,
      headers: { 
        'Authorization': token
      }
    };
    
    axios.request(config)
    .then((response) => {
      setcompanydata(response.data)
    })
    .catch((error) => {
      console.log(error);
    });
  };

  useEffect(() => {
    fetchCompanyByID();
  }, []);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const testBulk = (e) => {
    e.preventDefault();
  
    if (isSubmitting) {
      return;
    }
  
    setIsSubmitting(true);
  
    if (message_data.group_id === "") {
      navigate(0);
      return;
    }
  
    const formData = {
      message_body: message_data.message_body,
      message_id: id,
      rate: companydata.rate,
      company_id: logeduserData?.company_id,
    };
  
 // Normalize message_groups to an array of numbers only
const group_ids = Array.isArray(message_groups)
? message_groups.map((id) => Number(id))
: typeof message_groups === 'string'
  ? message_groups.split(',').map((id) => Number(id))
  : typeof message_groups === 'number'
    ? [message_groups]
    : [];

  
    // Log the converted group IDs to verify they are numbers
    console.log('Converted Group IDs:', group_ids);
  
    // Optionally, add an extra check on group_ids if needed
    if (group_ids.length === 0) {
      setIsSubmitting(false);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "No valid Group IDs found"
      });
      return;
    }
  
    // Create query parameters to pass all group IDs to the API
    const queryParameters = group_ids.map((groupId) => `groupid=${groupId}`).join('&');
    const url = `${API_URL}/postBulkSMS?${queryParameters}`;
  
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: url,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
      },
      data: formData,
    };
  
    axios.request(config)
      .then((response) => {
        setRecipient(response.data);
        setIsSubmitting(false);
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Lines loaded",
        }).then(() => {
          navigate(0);
        });
      })
      .catch((error) => {
        setIsSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.error,
        });
      });
  };
  

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const filteredtxt = generaldata.filter((recipient) => {
    const { phone_no, contact_name, message_body } = recipient;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return( 
      phone_no.toLowerCase().includes(lowerCaseSearchTerm) ||
      contact_name.toLowerCase().includes(lowerCaseSearchTerm) ||
      message_body.toLowerCase().includes(lowerCaseSearchTerm)
    );

  });


  const insertGeneral = () => {   
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    let sendGeneralData = generaldata.map((data) => ({
      phone_no: data.phone_no,
      // message_body: replaceFirstName(data.full_name.split(' ')[0]),
      message_body: data.message_body,
      message_subject: message_data.message_subject,
      message_id: id,
      company_id: logeduserData?.company_id,
      sender_id: logeduserData?.sender_id,
      sms_provider: logeduserData?.sms_provider,
      rate: companydata?.rate
    }));

      let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: `${API_URL}/postGeneralSMS`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
        data: sendGeneralData,
      };

      // console.log(sendGeneralData)

      axios
        .request(config)
        .then(() => {
          setIsSubmitting(false);
          Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: 'Message sent successfully',
          })
          .then(() => {
            navigate("/recent_sms");
          })
        })
        .catch(() => {
          setIsSubmitting(false);
          Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: 'Message failed',
          });
        });
  };  

  const messageGroup = message_data.group_id

  const [editmodalIsOpen, setEditIsOpen] = useState(false);
  const openEditModal = () => {
    setEditIsOpen(true);
    // console.log(message_data)
  }

  const closeEditModal = () => {
    setEditIsOpen(false);
  }

  const [contactgroups, setContactgroups] = useState([]);

  const [smsdata, setsmsData] = useState({
    message_subject: "",
    message_body: "",
    sms_groups: [],
    group_id: []
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setsmsData((prevState) => ({
      ...prevState,
      [id]: value
    }));
  };
  const fetchContactGroups = () => {
    const getContactGroupssURL = `${API_URL}/get_groupsByCompanyid/${logeduserData?.company_id}?page=1&limit=5000`;
    let getContactsConfig = {
      method: 'get',
      maxBodyLength: Infinity,
      url: getContactGroupssURL,
      headers: { 
        'Authorization': token
      }
    };

    axios
    .request(getContactsConfig)
    .then((response) => {
      const formattedOptions = response.data.map((group) => ({
        value: group.id,
        label: group.group_name
      }));
      setContactgroups(formattedOptions);
    })
    .catch((error) => {
      console.log(error?.response)
    });
  };
  useEffect(() => {
    fetchContactGroups();
  }, []);

  const editMessage = (e) => {
    e.preventDefault()
    // console.log(smsdata)
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    let editdata = {
      messageid: id,
      message_subject: smsdata.message_subject,
      message_body: smsdata.message_body,
      group_id: smsdata.group_id,
      sms_groups: smsdata.sms_groups,
    };
    
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${API_URL}/edit_draft_sms/${id}`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data: editdata
    };

    axios.request(config)
      .then((response) => {
        setIsSubmitting(false);
        clearLinesAfterEdit();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Message edited successfully",
        })
        .then(() => {
          navigate(0);
        });
      })
      .catch((error) => {
        if (error?.response?.status === 401) {
          navigate(0);
        }else{
          setIsSubmitting(false);
           Swal.fire({
              icon: "error",
              title: "Error!",
              text: error?.response?.data?.error,
            })
        }
      });
    
  }

  const [totalMessages, setTotalMessages] = useState(0);
  useEffect(() => {
    const messageLength = smsdata.message_body.length;
    const totalChars = 163;
    let newTotalMessages = 1;

    if (messageLength > 0) {
      newTotalMessages = Math.ceil(messageLength / totalChars);
    }

    if (newTotalMessages === 0) {
      newTotalMessages = 1;
    }

    setTotalMessages(newTotalMessages);
  }, [smsdata.message_body]);

  const calculateRemainingCharacters = () => {
    const totalCharacters = 163;
    let remainingCharacters

    if ((smsdata.message_body.length % totalCharacters) == 0 && smsdata.message_body.length !== 0) {
      remainingCharacters = 0;
    }
    else{
      remainingCharacters = totalCharacters - (smsdata.message_body.length % totalCharacters);
    }

    return { total: totalMessages, remaining: remainingCharacters };
  };

  const { total, remaining } = calculateRemainingCharacters();

  const clearLinesAfterEdit = () => {
        let config = {
          method: 'delete',
          maxBodyLength: Infinity,
          url: `${API_URL}/deleteMessageLinesById/${id}/${logeduserData?.company_id}`,
          headers: {
            'Authorization': token
          }
        };
        axios.request(config)
        .then((response) => {
          
        })
        .catch((error) => {
          
        });
  }
  

const clearLines = () => {
  if (isSubmitting) {
    return;
  }

  Swal.fire({
    title: 'Are you sure you want to clear?',
    text: 'This action cannot be undone.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    setIsSubmitting(true);
    if (result.isConfirmed) {
      let config = {
        method: 'delete',
        maxBodyLength: Infinity,
        url: `${API_URL}/deleteMessageLinesById/${id}/${logeduserData?.company_id}`,
        headers: {
          'Authorization': token
        }
      };
      
      axios.request(config)
      .then((response) => {
        setTimeout(() => {
          setIsSubmitting(false);
          Swal.fire({
            title: 'Deleted!',
            text: 'The lines have been deleted.',
            icon: 'success',
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false
          })
          .then(() => {
            navigate(0);
          });
        }, 1000);
      })
      .catch((error) => {
        setIsSubmitting(false);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error?.response?.data?.error,
        })
      });
    }
  });
}

// const selectedGroups = contactgroups.filter(group => smsdata?.group_id?.includes(group?.value.toString()));
// const selectedGroups = contactgroups?.filter(group => {
//   if (smsdata && smsdata?.group_id !== null) {
//     const selectedGroupIds = smsdata?.group_id?.split(','); // Convert to an array of IDs
//     if(selectedGroupIds){
//       return selectedGroupIds.includes(group?.value?.toString());
//     }
//   }
//   return false;
// });
const selectedGroups = contactgroups?.filter(group => {
  if (smsdata?.group_id !== null && typeof smsdata.group_id === 'string') {
    const selectedGroupIds = smsdata.group_id.split(','); // Convert to an array of IDs
    return selectedGroupIds.includes(group.value?.toString()) ?? false;
  }
  return false;
});

const retrySendSms = () => {
  if (isSubmitting) {
    return;
  }

  setIsSubmitting(true);

  let sendGeneralData = generaldata.map((data) => ({
    phone_no: data.phone_no,
    // message_body: replaceFirstName(data.full_name.split(' ')[0]),
    message_body: data.message_body,
    message_subject: message_data.message_subject,
    message_id: id,
    company_id: logeduserData?.company_id,
    sender_id: logeduserData?.sender_id,
    sms_provider: logeduserData?.sms_provider,
    rate: companydata?.rate
  }));

    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/retrypostGeneralSMS`,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token
      },
      data: sendGeneralData,
    };

    // console.log(sendGeneralData)

    axios
      .request(config)
      .then(() => {
        setIsSubmitting(false);
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Message sent successfully',
        })
        .then(() => {
          navigate("/recent_sms");
        })
      })
      .catch(() => {
        setIsSubmitting(false);
        Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Message failed',
        });
      });
}


  return (
    <div style={{marginTop: '60px'}}>

      {isSubmitting && (
        <div className="loadingsubcontainer loading-overlay">
          <img className="loadingsubimg" src={loading1} alt="" />
        </div>
      )}

      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card card-primary card-outline">
                  <div className="card-header">
                    <div className='row'>
                    <div className=''>
                      <h3 className="card-title">Subject: {message_data.message_subject}</h3>
                      <div className=' float-right '>
                        {smsStatus == 0 ? (<div  >
                        <button className="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Options
                          <span className="caret" /></button>
                        <ul className= "dropdown-menu companyActions">
                        {/* <li  onClick={retrySendSms}><i className="fa fa-pencil"></i>
                            Retry
                          </li> */}
                          { generaldata.length > 0 ? (<li onClick={insertGeneral}><i className="fa fa-paper-plane"></i>
                            Send SMS
                          </li>) : (<li onClick={testBulk}><i className="fa fa-list"></i>
                            Load lines
                          </li>)}
                          <li  onClick={openEditModal}><i className="fa fa-pencil"></i>
                            Edit
                          </li>
                          { generaldata.length > 0 ? (<li onClick={clearLines}><i className="fa fa-trash"></i>
                            Clear lines
                          </li>) : ""}
                        </ul>
                      </div>): ""}
                    </div>
                    </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="form-group">Message: {message_data.message_body}</div>
                    {messageGroup ? (<div className="form-group">Groups: {message_data.sms_groups}</div>):""}
                    <div className="form-group">Total Lines: {message_data.total_count}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal
          isOpen={editmodalIsOpen}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <div className="containernewcompany">
            <div className="title">
              Edit Message
              <i onClick={closeEditModal} className="fa fa-window-close red-close-icon" aria-hidden="true"></i>
            </div>
            <div className="content">
              <form onSubmit={editMessage}> 
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">Group</span>
                      <Select
                        options={contactgroups}
                        isMulti
                        placeholder="Select contact group:"
                        className='unitsINPUT'
                        required
                        value={selectedGroups}
                        onChange={(selectedOptions) => {
                          const selectedIds = selectedOptions.map(option => option.value).join(',');
                          const selectedIdLabels = selectedOptions.map(option => option.label).join(',');
                          setsmsData({
                            ...smsdata,
                            group_id: selectedIds,
                            sms_groups: selectedIdLabels
                          });
                        }}
                        id='group_id'
                      />
                  </div>
                </div>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">Subject</span>
                    <input type="text" 
                      placeholder="Enter subject"
                      className='unitsINPUT'
                      onChange={handleChange}
                      id='message_subject'
                      value={smsdata.message_subject}
                    />
                  </div>
                </div>
                <div className="user-details">
                  <div className="input-box">
                    <span className="details">Message</span>
                    <input type="text" 
                      placeholder="Enter message"  
                      className='unitsINPUT'
                      onChange={handleChange}
                      id='message_body'
                      value={smsdata.message_body}
                    />
                  </div>
                </div>
                <div style={{float: 'right', marginRight: '10px'}}>{remaining}/{total}</div>
                <div className="button">
                  <input type="submit" defaultValue="Update" />
                </div>
              </form>
            </div>
          </div>

        </Modal>

      <form className="form-inline justify-content-end searchBar">
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

        <InfiniteScroll

        dataLength={filteredtxt.length}
        next={loadMoreMessages}
        hasMore={hasMore}
        loader={filteredtxt.length > 0 ? null : 
        <div className="loadingsubcontainer">
        <img className="loadingsubimg" src={loading1} alt="" />
        </div>}
        endMessage={<p>No more messages to load.</p>}
    >
     <table id="example" className="table table-striped">
          <thead>
            <tr>
              <th>Phone No</th>
              <th>Recipient</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            {filteredtxt.map((recipient, id) => (
              <tr key={id}>
                <td>{recipient.phone_no}</td>
                <td>{recipient.contact_name}</td>
                <td>{recipient.message_body}</td>
              </tr>
            ))}
          </tbody>
        </table>
    </InfiniteScroll>
        
    </div>
  );
}

export default SendNewMessage;
